import { View } from "react-native";
import React, { useMemo, useState } from "react";
import SectionTitle from "./components/SectionTitle";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";
import { Input, Text } from "@ui-kitten/components";
import { FontAwesome, MaterialCommunityIcons } from "@expo/vector-icons";
import Accordion from "react-native-collapsible/Accordion";
import Container from "components/Container";

type Faq = {
  question: string;
  answer: string;
};
const Faqs = ({
  faqs,
}: {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
}) => {
  const { data: branding } = useFetchTenantBrandingQuery();

  const [activeSections, setActiveSections] = useState<number[]>([]);
  const [keywords, setKeywords] = useState("");

  const filteredFaqs = useMemo(() => {
    return faqs.filter((faq) => {
      return (
        faq.question.toLowerCase().indexOf(keywords) >= 0 ||
        faq.answer.toLowerCase().indexOf(keywords) >= 0
      );
    });
  }, [faqs, keywords]);

  const renderHeader = (faq: Faq, expanded: boolean) => {
    return (
      <View className="flex-row justify-between p-10 bg-white rounded-lg my-2">
        <Text>{faq.question}</Text>
        {expanded ? (
          <MaterialCommunityIcons size={24} name="minus" />
        ) : (
          <MaterialCommunityIcons size={24} name="plus" />
        )}
      </View>
    );
  };

  const renderContent = (faq: Faq) => {
    return (
      <View className="p-8">
        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
      </View>
    );
  };

  const faqExpanded = (faq: Faq) => {
    if (activeSections.length === 0) return false;
    return filteredFaqs[activeSections[0]].question === faq.question;
  };

  const onChangeText = (text: string) => {
    // when user resets input, reset active sections
    if (text === "") {
      setActiveSections([]);
    }
    setKeywords(text);
  };
  return (
    <View className="px-4 md:px-16 bg-slate-100 pt-4 pb-8 lg:pt-24 -z-10">
      <Container>
        <SectionTitle
          title="FAQs"
          color={branding!.primaryColor}
        ></SectionTitle>

        <View>
          <Text category="h3">Have questions? We&#39;re here to help</Text>
        </View>

        <View className="mt-4">
          <Input
            placeholder="Seach keywords"
            style={{ borderRadius: 9999, borderColor: "black" }}
            accessoryLeft={
              <FontAwesome name="search" size={24} color="black" />
            }
            onChangeText={onChangeText}
          />
        </View>

        <View className="mt-4">
          <Accordion
            underlayColor="transparent"
            activeSections={activeSections}
            sections={filteredFaqs}
            renderHeader={(faq) => renderHeader(faq, faqExpanded(faq))}
            renderContent={renderContent}
            onChange={setActiveSections}
          ></Accordion>
        </View>
      </Container>
    </View>
  );
};

export default Faqs;
